import { render, staticRenderFns } from "./SchoolSendMailModal.vue?vue&type=template&id=38965ca4&"
import script from "./SchoolSendMailModal.vue?vue&type=script&lang=js&"
export * from "./SchoolSendMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports